

import React, { memo, useState, useEffect } from 'react';
import { COLOURS, Text } from '../../../../../ui-kit';
import { uploadEvents } from '../../../../Uploader/utils/UploadEvents';
import '../styles/_upload.scss';







const ERROR_STATUS = 'error';

function getColourFromUploadStatus(uploadStatus) {
  return uploadStatus !== ERROR_STATUS ?
  COLOURS.cyan.jungleGreen.monkey :
  COLOURS.red.alizarinCrimson;
}

function Upload({ loadedPercent: initialLoadedPercent, uploadStatus, assetId }) {
  const [{ hasLoaded }, setLoaded] = useState({ hasLoaded: initialLoadedPercent === 100 });

  // Add state for tracking real-time progress
  const [progress, setProgress] = useState({
    loadedPercent: initialLoadedPercent
  });

  // Listen to progress events if assetId is provided
  useEffect(() => {
    if (!assetId) {
      return () => {}; // Return empty cleanup function
    }

    function onProgress({ assetId: eventAssetId, loaded, totalSize }) {
      if (eventAssetId === assetId) {
        const percent = Math.round(loaded / totalSize * 100);
        setProgress({ loadedPercent: percent });
      }
    }

    uploadEvents.on('progress', onProgress);
    return () => {
      uploadEvents.off('progress', onProgress);
    };
  }, [assetId]);

  // Use the most current value (from events or props)
  const currentLoadedPercent = progress.loadedPercent !== undefined ?
  progress.loadedPercent :
  initialLoadedPercent;

  if (currentLoadedPercent === void 0 || hasLoaded) {return null;}

  if (currentLoadedPercent === 100) {
    setTimeout(() => {
      setLoaded({ hasLoaded: true });
    }, 500);
  }

  const uploadText = currentLoadedPercent === 100 ? 'Uploaded' : 'Uploading';

  return (
    <div className="upload">
      <div className="upload__text">
        <Text heading3 noMargin centered darkTheme>{`${currentLoadedPercent}%`}</Text>
        <Text label noMargin centered darkTheme>{uploadStatus === ERROR_STATUS ? 'Error' : uploadText}</Text>
      </div>
      <div
        className="upload__bar"
        style={{
          width: `${currentLoadedPercent}%`,
          background: getColourFromUploadStatus(uploadStatus),
          transition: 'width 0.3s ease-out' // Add smooth animation
        }} />

    </div>);

}

// Add proper equality check for memoization
function arePropsEqual(prevProps, nextProps) {
  return (
    prevProps.loadedPercent === nextProps.loadedPercent &&
    prevProps.uploadStatus === nextProps.uploadStatus &&
    prevProps.assetId === nextProps.assetId);

}

export default memo(Upload, arePropsEqual);